export default "/_next/static/images/0d1950b827db012fc7eb780c414219e2.png";